import * as React from "react";

export function isArray(variable) {
    return variable instanceof Array;
}

export function isBool(variable) {
    return typeof variable === "boolean"
}

export function isDefined(variable) {
    return typeof variable !== 'undefined' && variable !== null;
}

export function isFunction(variable) {
    return typeof variable === 'function';
}

export function isObject(variable) {
    return isDefined(variable) && typeof variable === 'object';
}

export function isEmpty(variable) {
    return typeof variable === "undefined" || variable === null || variable === "" || variable === "undefined" || variable === "null";
}

export function isNumeric(value) {

    let valoresAceptados = /^[0-9]+$/;

    if (value.match(valoresAceptados)){
        return true;
    } else {
        return false;
    }

}

export  const patterEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export  const patterDocument = /^[0-9]{4,}$/
export const patterPhone = /^[0-9]{10}$/



